import { MOBILE_OS } from "@/configs/SDK";
import moment from "moment";
require("moment/locale/ja");
import { SYSTEM_MESSAGES } from "@/messages/System";
import { initScript, initMultiScript } from "@/ultis/Helper";

export default {
   name: "Helper Mixins",
   data() {
      return {
         isMobileLayoutSize: false,
         toast: {
            show: false,
            message: ""
         }
      };
   },
   created() {},
   methods: {
      initMultiScript,
      initScript,
      pad: function(num) {
         return ("0" + num).slice(-2);
      },
      formatStreamTime: function(secs) {
			let minutes = Math.floor(secs / 60);
			secs = secs % 60;
            let hours = this.pad(Math.floor(minutes / 60));
			minutes = minutes % 60;
            if (hours === "00")
                return `${this.pad(minutes)}:${this.pad(secs)}`;
            return `${hours}:${this.pad(minutes)}:${this.pad(secs)}`;
		},
      formatNumberToString: function(number) {
         let newValue = number;
         if (number >= 1000) {
            let suffixes = ["", "k", "m", "b", "t"];
            let suffixNum = Math.floor(("" + number).length / 3);
            let shortValue = "";
            for (let precision = 2; precision >= 1; precision--) {
               shortValue = parseFloat((suffixNum != 0 ? number / Math.pow(1000, suffixNum) : number).toPrecision(precision));
               let dotLessShortValue = (shortValue + "").replace(/[^a-zA-Z 0-9]+/g, "");
               if (dotLessShortValue.length <= 2) {
                  break;
               }
            }
            if (shortValue % 1 != 0) shortValue = shortValue.toFixed(1);
            newValue = shortValue + suffixes[suffixNum];
         }
         return newValue;
      },
      checkEmptyProperties(obj, excludeFields = []) {
         for (let key in obj) {
            if (excludeFields.indexOf(key) === -1 && (obj[key] === null || obj[key] === "")) return true;
         }
         return false;
      },

      /**
       * Determine the mobile operating system.
       * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
       *
       * @returns {String}
       */
      getMobileOperatingSystem: function() {
         var userAgent = navigator.userAgent || navigator.vendor || window.opera;

         // Windows Phone must come first because its UA also contains "Android"
         if (/windows phone/i.test(userAgent)) {
            return MOBILE_OS.WINDOW_PHONE;
         }

         if (/android/i.test(userAgent)) {
            return MOBILE_OS.ANDROID;
         }

         // iOS detection from: http://stackoverflow.com/a/9039885/177710
         if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return MOBILE_OS.iOS;
         }

         return MOBILE_OS.UN_KNOWN;
      },

      /**
       *
       * @returns {boolean}
       */
      checkBrowserSupportWebRTC: function() {
         var isWebRTCSupported =
            navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia ||
            window.RTCPeerConnection;

         if (!isWebRTCSupported || window.navigator.userAgent.indexOf("Edge") > -1) {
            return false;
         } else {
            return true;
         }
      },
      copyUrl: function(copyElement) {
         let element = document.getElementById(copyElement);
         element.setAttribute("type", "text");
         element.select();
         element.setSelectionRange(0, 99999);
         document.execCommand("copy");
         element.setAttribute("type", "hidden");
         element.blur();
         window.getSelection().removeAllRanges();
      },

      /**
       *
       * @param app
       */
      openMobileApp: function(app) {
         setTimeout(function() {
            window.location = app.DOWNLOAD_URL;
         }, 25);
         window.location = app.APP_INSTALLED_URL;
      },
      /**
       *
       * @param timeString
       * @param formatTime
       * @returns {string}
       */
      formatUTC: function(timeString) {
         let timeArray = timeString.split("T");
         if (timeArray.length === 2) {
            var resTime = timeArray[0]
               .split("/")
               .reverse()
               .join("-")
               .concat("T", timeArray[1]);
            var timestamp = new Date(resTime);
            return timestamp;
         }
         return SYSTEM_MESSAGES.INVALID_DATE;
      },
      /**
       *
       * @param timeString
       * @param formatTime
       * @returns {string}
       */
      formatUTCZulu: function(timeString, formatTime = "YYYY-MM-DD HH:mm:ss") {
         let timeArray = timeString.split("T");
         if (timeArray.length === 2) {
            return moment(this.formatUTC(timeString)).format(formatTime);
         }
         return SYSTEM_MESSAGES.INVALID_DATE;
      },

      /**
       *
       */
      onResize() {
         // We execute the same script as before
         let vh = window.innerHeight * 0.01;
         document.documentElement.style.setProperty("--vh", `${vh}px`);
         document.body.scrollTop = 0;

         if (window.innerWidth >= 992) {
            this.isMobileLayoutSize = false;
         } else {
            this.isMobileLayoutSize = true;
         }

         this.$root.$emit(`resize-browser`, this.isMobileLayoutSize);
      },

      /**
       *
       * @param num
       * @param fixed
       * @param decimalChar
       * @param separatorChar
       * @returns {string}
       */
      formatCurrency(num, fixed = 2, decimalChar = ",", separatorChar = ".") {
         return num
            .toFixed(fixed) // always two decimal digits
            .replace(".", decimalChar) // replace decimal point character with ,
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${separatorChar}`) // use . as a separator
            .replace(new RegExp(decimalChar + `00$`), ""); // remove .00
      },

      bytesToSize(bytes) {
         var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
         if (bytes == 0) return "n/a";
         var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
         if (i == 0) return bytes + " " + sizes[i];
         return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
      },

      notification(msg) {
         if (this.toast.show) return;
         this.toast = {
            show: true,
            message: msg
         };
         setTimeout(() => {
            this.toast = {
               show: false,
               message: ""
            };
         }, 5000);
      },

      /**
       *
       * @param dateTime
       * @param format
       * @param locale
       * @returns {string}
       */
      formatDateTimeByLocale(dateTime, format = "YYYY/MM/DD (ddd)", locale = "ja") {
         if (dateTime === SYSTEM_MESSAGES.INVALID_DATE) return null;

         moment.locale(locale);
         return moment(dateTime).format(format);
      },

      /**
       *
       * @param start
       * @param end
       * @param separatorChar
       * @returns {string|null|*}
       */
      linkTwoStrings(start, end, separatorChar = "~") {
         if (!start && !end) return null;
         else if (!start || !end) {
            return start || end;
         } else {
            return `${start}${separatorChar}${end}`;
         }
      },

      getCurrentLanguage(event) {
         return event.language !== undefined && event.language === 0 ? "en" : "ja";
      }
   }
};
